import { configureStore, createSlice } from '@reduxjs/toolkit';

// Initial state
const initialState = {
  token: "",
  Mobile_Number: "",
  global_sidebar_index_selector: 0,
  loan_data: {},
  Complete_Loan_Data: null,
  Complete_Service_List_Status: null,
  mode: localStorage.getItem('themeMode') || 'light',
  Profile_Data: null,
  OppertunityId: null,
  Loan_Sansaction_Date: null,
};

// Create a slice for global state
const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    setMode: (state) => {
      state.mode = state.mode === 'light' ? 'dark' : 'light';
      localStorage.setItem('themeMode', state.mode);
    },
    setToken: (state, action) => {
      state.token = action.payload;
    },
    setMobileNumber: (state, action) => {
      state.Mobile_Number = action.payload;
    },
    setGlobalSidebarIndexSelector: (state, action) => {
      state.global_sidebar_index_selector = action.payload;
    },
    setLoanData: (state, action) => {
      state.loan_data = action.payload;
    },
    setCompleteLoanData: (state, action) => {
      state.Complete_Loan_Data = action.payload;
    },
    setCompleteServiceListStatus: (state, action) => {
      state.Complete_Service_List_Status = action.payload;
    },
    setProfileData: (state, action) => {
      state.Profile_Data = action.payload;
    },
    setLoanSanctionDate: (state, action) => {
      state.Loan_Sansaction_Date = action.payload;
    },
    setOpportunityId: (state, action) => {
      state.OppertunityId = action.payload;
    },
  },
});

// Export actions
export const {
  setMode,
  setToken,
  setMobileNumber,
  setGlobalSidebarIndexSelector,
  setLoanData,
  setCompleteLoanData,
  setCompleteServiceListStatus,
  setProfileData,
  setLoanSanctionDate,
  setOpportunityId,
} = globalSlice.actions;

// Configure the store
const store = configureStore({
  reducer: globalSlice.reducer,
});

export default store;